
import { Slide, toast } from 'react-toastify';

const CommonToastFunctions = (type, message,) => {
    if (type === "success") {
        toast.success(message, {
            position: toast.POSITION.TOP_RIGHT,
            hideProgressBar: false,
            transition: Slide,
            autoClose: 2000,
            theme: "colored",
        });
    } else if (type === "warning") {
        toast.warn(message, {
            position: toast.POSITION.TOP_RIGHT,
            hideProgressBar: false,
            transition: Slide,
            autoClose: 2000,
            theme: "colored",
        });
    }
    else if (type === "error") {
        toast.error(message, {
            position: toast.POSITION.TOP_RIGHT,
            hideProgressBar: false,
            transition: Slide,
            autoClose: 2000,
            theme: "colored",
        });
    }
    else if (type === "info") {
        toast.info(message, {
            position: toast.POSITION.TOP_RIGHT,
            hideProgressBar: false,
            transition: Slide,
            autoClose: 2000,
            theme: "colored",
        });
    }
};

export default CommonToastFunctions;